module.exports = __webpack_public_path__ + "img/monitor-pad.4d996971.png";